module.exports = __webpack_public_path__ + "img/key.164a5046.svg";